module.exports = __webpack_public_path__ + "img/star.135ecca9.png";